import { CircleHelpIcon } from 'lucide-react'
import { Suspense } from 'react'

import { useDialog } from '@/lib/hooks/use-dialog'
import { cn } from '@/lib/utils'

import { ActiveCasesContent } from './active-cases/active-cases-content'
import { ActiveCasesContentLoading } from './active-cases/active-cases-content-loading'
import { ActiveCasesWrapper } from './active-cases/active-cases-wrapper'
import { CaseStatusGuideDialog } from './dialogs/case-status-guide-dialog/case-status-guide-dialog'
import { InactiveCasesContent } from './inactive-cases/inactive-cases-content'
import { InactiveCasesContentLoading } from './inactive-cases/inactive-cases-content-loading'
import { InactiveCasesWrapper } from './inactive-cases/inactive-cases-wrapper'

export const CaseUsageIndicator = () => {
  const {
    isDialogOpen: isOpenCaseStatusGuideDialog,
    openDialog: openCaseStatusGuideDialog,
    closeDialog: closeCaseStatusGuideDialog,
  } = useDialog()

  return (
    <div className={cn('flex items-center', 'space-x-1.5')}>
      <Suspense fallback={<ActiveCasesContentLoading />}>
        <ActiveCasesWrapper>
          <ActiveCasesContent />
        </ActiveCasesWrapper>
      </Suspense>
      <Suspense fallback={<InactiveCasesContentLoading />}>
        <InactiveCasesWrapper>
          <InactiveCasesContent />
        </InactiveCasesWrapper>
      </Suspense>
      <button type="button" onClick={openCaseStatusGuideDialog}>
        <CircleHelpIcon size={24} fill="#ABAFC9" className={cn('text-white')} />
      </button>
      {/* Dialog */}
      <CaseStatusGuideDialog open={isOpenCaseStatusGuideDialog} onClose={closeCaseStatusGuideDialog} />
    </div>
  )
}
